import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const ProgressBar = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Location' },
    { number: 2, label: 'Account' },
    { number: 3, label: 'Bike Details' },
    { number: 4, label: 'Payment' }
  ];

  return (
    <div className="bg-white rounded-2xl shadow-lg p-4 sm:p-6 border border-gray-200">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className="flex flex-col items-center flex-1">
              {/* Step Circle */}
              <div
                className={`
                  w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center font-bold text-sm sm:text-base
                  transition-all duration-300
                  ${
                    currentStep > step.number
                      ? 'bg-green-500 text-white'
                      : currentStep === step.number
                      ? 'bg-gradient-to-br from-indigo-600 to-purple-600 text-white shadow-lg scale-110'
                      : 'bg-gray-200 text-gray-500'
                  }
                `}
              >
                {currentStep > step.number ? (
                  <CheckCircleIcon className="h-6 w-6" />
                ) : (
                  step.number
                )}
              </div>

              {/* Step Label */}
              <p
                className={`
                  mt-2 text-xs sm:text-sm font-medium text-center
                  ${
                    currentStep >= step.number
                      ? 'text-indigo-600'
                      : 'text-gray-500'
                  }
                `}
              >
                {step.label}
              </p>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div className="flex-1 h-1 mx-2 sm:mx-4 mb-8">
                <div
                  className={`
                    h-full rounded-full transition-all duration-300
                    ${
                      currentStep > step.number
                        ? 'bg-green-500'
                        : currentStep === step.number
                        ? 'bg-gradient-to-r from-indigo-600 to-purple-600'
                        : 'bg-gray-200'
                    }
                  `}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
